import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const setupResizeObserverGuard = () => {
  if (typeof window === 'undefined') return;

  const resizeObserverMessagePattern = /^ResizeObserver loop (limit exceeded|completed with undelivered notifications)\.?$/i;
  const NativeResizeObserver = window.ResizeObserver;

  if (typeof NativeResizeObserver === 'function') {
    window.ResizeObserver = class ResizeObserver {
      constructor(callback) {
        this._observer = new NativeResizeObserver((entries, observer) => {
          window.requestAnimationFrame(() => {
            callback(entries, observer);
          });
        });
      }

      observe(target, options) {
        this._observer.observe(target, options);
      }

      unobserve(target) {
        this._observer.unobserve(target);
      }

      disconnect() {
        this._observer.disconnect();
      }
    };
  }

  const errorHandler = (event) => {
    const message = String(event?.message || '');
    if (resizeObserverMessagePattern.test(message)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return false;
    }
    return undefined;
  };

  window.onerror = (message) => {
    const text = String(message || '');
    if (resizeObserverMessagePattern.test(text)) {
      return true;
    }
    return false;
  };

  window.addEventListener('error', errorHandler, true);
  window.addEventListener('error', errorHandler);

  window.addEventListener('unhandledrejection', (event) => {
    const reasonMessage = String(event?.reason?.message || event?.reason || '');
    if (resizeObserverMessagePattern.test(reasonMessage)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  });
};

setupResizeObserverGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
